import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENTS_QUERY_KEY } from '../../queries/events/use-events.ts';

export const useDeleteEventMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      return deleteEvent(id, token ?? '');
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [GET_EVENTS_QUERY_KEY],
      });
    },
  });
};

const deleteEvent = async (id: string, token: string): Promise<void> => {
  const url = `${import.meta.env.VITE_API_URL}/events/${id}`;
  return sendJSONRequest({ url, method: METHOD.DELETE, token });
};

export default useDeleteEventMutation;
